/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LogoutInputs */



/**
* | output |
* | --- |
* | "Logout" |
*
* @param {LogoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const logout = /** @type {((inputs?: LogoutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LogoutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déconnexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abmelden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выйти")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar sesión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("注销")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ログアウト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग आउट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sair")
	return /** @type {LocalizedString} */ ("Logout")
});